export enum SessionStatusType {
  Expired = 0, // expired session
  Active = 1, // active session
  Completed = 2, // completed session
  Cancelled = 3, // canceled session
  Voided = 4, // voided session
  Returned = 5, // returned session
  Refunded = 6 // refunded session
}

export enum ZoneSlotStatusType {
  Vacant = 1, //slot vacant
  Occupied = 2, //slot occupied
}

export enum ZoneSlotActionType {
  Vacant = 1, //slot vacant
  AddPlate = 2, //slot add plate,
  AutoVacant = 3, // slot auto vacant
  AutoExpired = 4 // slot auto expired
}

export enum ZoneSlotAssignment {
  Automatic = 1, // automatic
  Manual = 2, // manual
}

export enum NotificationStatusType {
  Read = 1, //Read
  Unread = 2, //Unread
}

export enum PaymentType {
  Cash = 1, //Cash
  Gcash = 2, //Gcash
  Paymaya = 3, //Paymaya
  CreditCard = 4, //Credit Card
  Free = 5, //Credit Card
}

export enum PaymentActionType {
  InitialPayment = 1, //Initial Rate
  AdditionalPayment = 2, //Additional Payment
}

export enum PrintThermalType {
  PrintTransactionSlip = 0, // Print Transaction Slip
  RePrintTransactionSlip = 1, // Re Print Transaction Slip
  PrintReceipt = 2, // Print Receipt
  PrintSummary = 3 // Print Summary
}

export enum TransactionType {
  SelfDrive = 0, // Self drive service transaction
  ValetDrive = 1, // Valet drive service transaction
  VipPaid = 2, // VIP paid service transaction
  VipFree = 3, // VIP free service transaction
  VipValet = 4, // VIP paid service transaction
}
